import { Button } from "../../components/ui/button"
import {
    Dialog,
    DialogContent,
    // DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../components/ui/dialog"
import { Input } from "../../components/ui/input"
import { Label } from "../../components/ui/label"

const AddPaymentMethodPopUp = ({ isOpen, onClose }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}  className="">
            <DialogContent className="p-4 sm:p-6 bg-gray-0  max-w-full sm:max-w-[588px] responsive-mobile flex flex-col sm:flex-col justify-between sm:justify-center rounded-t-xl" closeClassname="remove-boxshadow top-7 right-7" closeIconClassname="">
                <div>
                    <DialogHeader >
                        <DialogTitle className="text-center text-gray-700 text-base font-bold font-redhat pb-5" >Add card details</DialogTitle>
                    </DialogHeader>
                    <div className="flex flex-col gap-5">
                        <div className="flex items-left sm:items-center flex-col sm:flex-row gap-5">
                            <div className="relative w-4/4 sm:w-3/4">
                                <Input
                                    type="number"
                                    id="card_number"
                                    className="remove-boxshadow text-gray-500 border border-gray-100 rounded-lg h-40 outline-none peer"
                                    placeholder=" "
                                />

                                <Label htmlFor="card_number"
                                    className="bg-gray-0 absolute left-4 -top-[10px] text-gray-500 text-sm leading-0 font-medium font-redhat transition-all peer-placeholder-shown:top-2"
                                >Card Number*</Label>
                            </div>
                            <div className="w-1/4">
                                <img src={`${process.env.PUBLIC_URL}/media/images/cards.png`} alt="" />
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="relative w-1/2">
                                <Input type="text" id="cvv"
                                    className="remove-boxshadow text-gray-500 border border-gray-100 rounded-lg h-40 outline-none peer"
                                    placeholder=" " />
                                <Label htmlFor="cvv"
                                    className="bg-gray-0 absolute left-4 -top-[10px] text-gray-500 text-sm leading-0 font-medium font-redhat transition-all peer-placeholder-shown:top-2"
                                >CVV*</Label>
                            </div>
                            <div className="relative w-1/2">
                                <Input type="number" id="mm_yy"
                                    className="remove-boxshadow text-gray-500 border border-gray-100 rounded-lg h-40 outline-none peer"
                                    placeholder=" " />
                                <Label htmlFor="mm_yy"
                                    className="bg-gray-0 absolute left-4 -top-[10px] text-gray-500 text-sm leading-0 font-medium font-redhat transition-all peer-placeholder-shown:top-2"
                                >MM / YY*</Label>
                            </div>
                        </div>
                        <div className="relative">
                            <Input type="text" id="ZIP_code"
                                className="remove-boxshadow text-gray-500 border border-gray-100 rounded-lg h-40 outline-none peer"
                                placeholder=" " />
                            <Label htmlFor="ZIP_code"
                                className="bg-gray-0 absolute left-4 -top-[10px] text-gray-500 text-sm leading-0 font-medium font-redhat transition-all peer-placeholder-shown:top-2"
                            >ZIP code</Label>
                        </div>

                        <div className="pb-2">
                            <select
                                id="Country_region"
                                className="w-full remove-boxshadow bg-gray-0 text-gray-500 border border-gray-100 rounded-lg h-40 outline-none"
                            >
                                <option value="" className="text-gray-500">Country/region</option>
                                <option value="USA">United States</option>
                                <option value="Canada">Canada</option>
                                <option value="UK">United Kingdom</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="hidden sm:block w-[calc(100%+48px)] mx-[-24px] border-t border-gray-100"></div>
                    <DialogFooter className="flex !justify-between gap-4 pt-5">
                        <div className="w-full sm:w-1/2">
                            <DialogTrigger asChild className="bg-gray-0 hover:bg-gold-300 hover:text-gray-0 border border-gray-100 rounded-[34px] w-full text-gold-300 text-base font-semibold font-redhat">
                                <Button variant="outline">
                                    Cancel
                                </Button>
                            </DialogTrigger>
                        </div>
                        <div className="w-full sm:w-1/2">
                            <Button className="bg-gray-400 hover:bg-gold-300 hover:text-gray-0 border-0 rounded-[34px] w-full text-gray-0 text-base font-semibold font-redhat" type="submit">Done</Button>
                        </div>
                    </DialogFooter>

                </div>

            </DialogContent>
        </Dialog>
    )
}

export default AddPaymentMethodPopUp;
